module.exports = __webpack_public_path__ + "img/Terrace-Outdoor.01de2acf.png";